export const getMerchantOrderTotal = (order, merchantId) => {
  if (!merchantId) return 0;
  return (order.items || [])
    .filter((item) => {
      const id = item.merchant?._id || item.merchant;
      return id?.toString() === merchantId?.toString();
    })
    .reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);
};

export const getMerchantItems = (order, merchantId) =>
  (order.items || []).filter((item) => {
    const id = item.merchant?._id || item.merchant;
    return id?.toString() === merchantId?.toString();
  });

export { LOW_STOCK_THRESHOLD, isLowStock, getMerchantProductStock, isOutOfStock } from "./productStock";
